import { Link } from 'gatsby';
import "../../../../src/pages/design/design-guidelines-styles.css";
import { DocsHeading } from "../../../../src/components/DocsHeading";
import { Button, Paragraph, Heading } from 'react-magma-dom';
import * as React from 'react';
export default {
  Link,
  DocsHeading,
  Button,
  Paragraph,
  Heading,
  React
};